import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "../Utils/ScrollTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./ProtectedRoutes";
import Login from "../Pages/Login/Page";
import Signup from "../Pages/SignUp/Page";
import Forgot from "../Pages/ForgotPassword/page";
import NewPassword from "../Pages/NewPassword/Page";
import Dashboard from "../Pages/Dashboard/Page";
import Profile from "../Pages/Profile/Page";
import PRmanager from "../Pages/PRmanager/Page";
import PRaction from "../Pages/PRaction/Page";
import PRpending from "../Pages/PRpending/Page";
import PRpublish from "../Pages/PRpublish/Page";
import PRdraft from "../Pages/PRdraft/Page";
import PRreject from "../Pages/PRreject/Page";
import PRreport from "../Pages/PRreport/Page";
import SubmitPR from "../Pages/SubmitPr/Page";
import SubAccount from "../Pages/SubAccount/Page";
import SubAccountCreate from "../Pages/SubAccountAdd/Page";
import SubAccountUpdate from "../Pages/SubAccountUpdate/Page";
import Gallery from "../Pages/Gallery/Page";
import Payment from "../Pages/Payment/Page";
import AffiliateCenter from "../Pages/AffiliateCenter/Page";
import Support from "../Pages/Support/Page";
import SupportAdd from "../Pages/SupportAdd/Page";
import Contact from "../Pages/Contact/Page";
import Notification from "../Pages/Notification/Page";
import BuyCredits from "../Pages/BuyCredits/Page";
import CreditPayment from "../Pages/CreditPayment/Page";
import PaymentMethod from "../Pages/PaymentMethod/Page";
import NewsRoom from "../Pages/Newsroom/Page";
import NewsRoomDetails from "../Pages/NewsroomDetails/Page";
import PRupdate from "../Pages/PRUpdate/Page";
import PRviewPage from "../Pages/PRview/Page";
import PackageDetailsPage from "../Pages/PackageDetails/Page";
import ConfirmationPage from "../Pages/Confirmation/Page";

export default function AllRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer theme="colored" />
      <Routes>

        {/* Public Routes */}

        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/newpassword" element={<NewPassword />} />

        {/* Protected Routes */}


        <Route path="/customer/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/customer/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="/customer/pr-manager" element={
          <ProtectedRoute>
            <PRmanager />
          </ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/edit/:id" element={
          <ProtectedRoute>
            <PRupdate />
          </ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/view/:id" element={
          <ProtectedRoute>
            <PRviewPage />
          </ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/report" element={
          <ProtectedRoute>
            <PRreport />
          </ ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/action" element={
          <ProtectedRoute>
            <PRaction />
          </ ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/pending" element={
          <ProtectedRoute>
            <PRpending />
          </ ProtectedRoute>
        } />
        <Route path="/customer/pr-manager/publish" element={
          <ProtectedRoute>
            <PRpublish />
          </ ProtectedRoute>} />
        <Route path="/customer/pr-manager/draft" element={
          <ProtectedRoute>
            <PRdraft />
          </ ProtectedRoute>} />
        <Route path="/customer/pr-manager/reject" element={
          <ProtectedRoute>
            <PRreject />
          </ ProtectedRoute>
        } />
        <Route path="/customer/submit-pr" element={
          <ProtectedRoute>
            <SubmitPR />
          </ ProtectedRoute>
        } />
        <Route path="/customer/sub-account" element={
          <ProtectedRoute>
            <SubAccount />
          </ ProtectedRoute>
        } />
        <Route path="/customer/sub-account/add" element={
          <ProtectedRoute>
            <SubAccountCreate />
          </ ProtectedRoute>
        } />
        <Route path="/customer/sub-account/edit/:subID" element={
          <ProtectedRoute>
            <SubAccountUpdate />
          </ ProtectedRoute>
        } />
        <Route path="/customer/gallery" element={
          <ProtectedRoute>
            <Gallery />
          </ ProtectedRoute>
        } />
        <Route path="/customer/payment" element={
          <ProtectedRoute>
            <Payment />
          </ ProtectedRoute>
        } />
        <Route path="/customer/affiliate-center" element={
          <ProtectedRoute>
            <AffiliateCenter />
          </ ProtectedRoute>
        } />
        <Route path="/customer/support" element={
          <ProtectedRoute>
            <Support />
          </ ProtectedRoute>
        } />
        <Route path="/customer/support/add" element={
          <ProtectedRoute>
            <SupportAdd />
          </ ProtectedRoute>
        } />
        <Route path="/customer/contact" element={
          <ProtectedRoute>
            <Contact />
          </ ProtectedRoute>
        } />
        <Route path="/customer/notification" element={
          <ProtectedRoute>
            <Notification />
          </ ProtectedRoute>
        } />
        <Route path="/customer/pricing" element={
          <ProtectedRoute>
            <BuyCredits />
          </ ProtectedRoute>
        } />
        <Route path="/customer/pricing/:id" element={
          <ProtectedRoute>
            <CreditPayment />
          </ ProtectedRoute>
        } />
        <Route path="/customer/payment_method/:id" element={
          <ProtectedRoute>
            <PaymentMethod />
          </ ProtectedRoute>
        } />
        <Route path="/customer/newsroom" element={
          <ProtectedRoute>
            <NewsRoom />
          </ProtectedRoute>
        } />
        <Route path="/customer/newsroom/:id/:slug" element={
          <ProtectedRoute>
            <NewsRoomDetails />
          </ProtectedRoute>
        } />
        <Route path="/customer/package-details" element={
          <ProtectedRoute>
            <PackageDetailsPage />
          </ProtectedRoute>
        } />
        <Route path="/customer/confirmation/:status" element={
          <ProtectedRoute>
            <ConfirmationPage />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}